import api, { createApiService } from "../http"
import { ISubjectRights } from "../types/services-types/subject-rights-types"

export default class SubjectRightsService {

    static apiSubjectRightsService = createApiService('/subject-rights')

    static async Add(name: string) {
        const response = await this.apiSubjectRightsService.post<ISubjectRights>(`/create`, {
            name
        })
        return response.data
    }

    static async Get(id: number | string) {
        const response = await this.apiSubjectRightsService.get<ISubjectRights>(`/${id}`)
        return response.data
    }

    static async GetAll(limit = 100, page = 0) {
        const response = await this.apiSubjectRightsService.get<ISubjectRights[]>(`/all`, {
            params: {
                limit,
                page
            }
        })
        return response.data
    }

    static async Remove(id: number | string) {
        const response = await this.apiSubjectRightsService.get(`/remove/${id}`)
        return response.data
    }

    static async Update(id: number | string, name: string) {
        const response = await this.apiSubjectRightsService.post<ISubjectRights>(`/update`, {
            id,
            name
        })
        return response.data
    }
}